import React from 'react'
import { l } from '@manychat/manyui'

import { IBlock } from 'common/builder/blocks/blockInterfaces'
import { BlockType } from 'common/builder/constants/BlockType'
import { getBlockUrl } from 'common/builder/utils/getBlockUrl'

import { StatsViewer } from '../StatsViewer/StatsViewer'

interface BlockStatsViewerProps {
  builderId: string
  block: IBlock
}

export const BlockStatsViewer = ({ builderId, block }: BlockStatsViewerProps) => {
  if (block && block.type === BlockType.CARD && block.isCardHidden) {
    return <div className="p-a">{l.translate('Unable to show statistics for hidden card')}</div>
  }

  return <StatsViewer builderId={builderId} stats={block.stats} url={getBlockUrl(block)} />
}
